export default "__VITE_ASSET__BOBU9kxM__"